export const LeaveRequestPaths = {
  MANAGE_REQUEST_LEAVE_REQUEST: 'leave-request',
  MANAGE_REQUEST_CREATE_LEAVE_REQUEST: 'create',
  MANAGE_REQUEST_EDIT_LEAVE_REQUEST: 'edit/:requestId',
};
